import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { ShellComponent } from './layout/shell/shell.component';
import { pendingExitGuard } from '../guards/pending-exit.guard';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'archive', pathMatch: 'full' },
      {
        path: 'inbox',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/inbox/inbox.component').then(m => m.InboxComponent),
          },
          {
            path: 'detail',
            data: { mainView: 'da-classificare' },
            canDeactivate: [pendingExitGuard],
            loadComponent: () =>
              import('./shared/components/dettaglio-messaggio/dettaglio-messaggio.component').then(
                m => m.DettaglioMessaggioComponent,
              ),
          },
        ],
      },
      {
        path: 'sent',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/sent/sent.component').then(m => m.SentComponent),
          },
          {
            path: 'detail',
            data: { mainView: 'inviati' },
            loadComponent: () =>
              import('./shared/components/dettaglio-messaggio/dettaglio-messaggio.component').then(
                m => m.DettaglioMessaggioComponent,
              ),
          },
        ],
      },
      {
        path: 'archive',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/archive/archive.component').then(m => m.ArchiveComponent),
          },
          {
            path: 'detail',
            data: { mainView: 'archivio' },
            loadComponent: () =>
              import('./shared/components/dettaglio-messaggio/dettaglio-messaggio.component').then(
                m => m.DettaglioMessaggioComponent,
              ),
          },
        ],
      },
      {
        path: 'drafts',
        loadComponent: () => import('./pages/drafts/drafts.component').then(m => m.DraftsComponent),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./pages/search/search-results.component').then(m => m.SearchResultsComponent),
      },
      {
        path: 'contacts',
        loadComponent: () =>
          import('./pages/contacts/contacts.component').then(m => m.ContactsComponent),
      },
      {
        path: 'postal',
        loadComponent: () => import('./pages/postal/postal.component').then(m => m.PostalComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings.component').then(m => m.SettingsComponent),
      },
      {
        path: 'settings/mailbox/config-provider',
        loadComponent: () =>
          import('./pages/settings/mailbox/config-provider-mailbox/config-provider-mailbox.component').then(
            m => m.ConfigProviderMailboxComponent,
          ),
      },
      {
        path: 'settings/offices',
        loadComponent: () =>
          import('./pages/settings/offices-assignment/offices-assignment.component').then(
            m => m.OfficesAssignmentComponent,
          ),
      },
      {
        path: 'settings/users-mailboxes',
        loadComponent: () =>
          import('./pages/settings/users-mailboxes/users-mailboxes.component').then(
            m => m.UsersMailboxesComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
